import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { DirectiveModule } from '@Shared/Directives/proprietary/directive.module';
import { ObjectCompareContractDialogComponent } from './object-compare-contract-dialog/object-compare-contract-dialog.component';

@NgModule({
    imports: [SharedPageModule, NgbTooltipModule, DirectiveModule],
    declarations: [ObjectCompareContractDialogComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ObjectCompareDialogModule { }
